import React, { useState } from "react";

import useOpenReferral from "hooks/query/useOpenReferral";
import useShowSnackBar from "hooks/snackBar/useShowSnackBar";
import useCloseModal from "hooks/modal/useCloseModal";

import Button from "components/Button";
import ModalContainer from "../ModalContainer";

import s from "./ReferralAccessModal.module.scss";

interface Props {
  open: boolean;
  close: () => void;
}

function ReferralAccessModal({ open, close }: Props) {
  const { isClosing, onClose } = useCloseModal(close);
  const { mutateAsync: requestReferral } = useOpenReferral();
  const showSnackBar = useShowSnackBar();
  const [userInfo, setUserInfo] = useState("");

  const userInfoChangeHandler = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setUserInfo(e.target.value);
  };

  const formSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!userInfo) {
      showSnackBar({
        title: "Error",
        text: "No info about you :(",
        variant: "error",
      });
      return;
    }

    await requestReferral({ description: userInfo });
    onClose();
  };

  return (
    <ModalContainer open={open} onClose={onClose} isClosing={isClosing}>
      <div className={s.modalWindowWrapper}>
        <div className={s.modalWindow}>
          <div className={s.summeryWrapper}>
            <div className={s.summery}>
              <div className={s.title}>access to referral system</div>
              <button type="button" className={s.close} onClick={onClose}>
                <span className="icon-close" />
              </button>
            </div>
          </div>
          <div className={s.content}>
            <div className={s.title}>Referral request form</div>
            <div className={s.text}>
              The Trace referral system is designed for influencers around the
              world. Bring value and get rewarded! Apply by telling us about
              yourself and your amazing experience:
            </div>
            <form className={s.inputWrapper} onSubmit={formSubmit}>
              <textarea
                name="userInfo"
                value={userInfo}
                onChange={userInfoChangeHandler}
                className={s.userInfo}
                placeholder="Tell us about yourself"
              />
              <Button className={s.submit} type="submit">
                Send
              </Button>
            </form>
          </div>
        </div>
      </div>
    </ModalContainer>
  );
}

export default ReferralAccessModal;
